(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_bannerproduct"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var closeTimers = new WeakMap();

    function initBanner(root) {
      var hotspots = Array.prototype.slice.call(root.querySelectorAll('[data-cbp-hotspot]'));

      function open(spot) {
        var card = spot.querySelector('[data-cbp-card]');
        var toggle = spot.querySelector('[data-cbp-toggle]');
        if (!card || !toggle) return;
        if (closeTimers.has(spot)) {
          window.clearTimeout(closeTimers.get(spot));
          closeTimers.delete(spot);
        }
        card.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }

      function close(spot, immediate) {
        var card = spot.querySelector('[data-cbp-card]');
        var toggle = spot.querySelector('[data-cbp-toggle]');
        if (!card || !toggle) return;

        var doClose = function () {
          card.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          closeTimers.delete(spot);
        };

        if (immediate) {
          doClose();
        } else {
          var timer = window.setTimeout(doClose, 150);
          closeTimers.set(spot, timer);
        }
      }

      function closeAll(except) {
        hotspots.forEach(function (spot) {
          if (spot !== except) close(spot, true);
        });
      }

      hotspots.forEach(function (spot) {
        var toggle = spot.querySelector('[data-cbp-toggle]');
        var card = spot.querySelector('[data-cbp-card]');
        var closeBtn = spot.querySelector('[data-cbp-close]');

        if (!toggle || !card) return;

        /* Click / tap — works on touch, desktop, and keyboard (Enter/Space) */
        toggle.addEventListener('click', function (event) {
          event.stopPropagation();
          var isOpen = !card.hidden;
          closeAll(spot);
          if (isOpen) {
            close(spot, true);
          } else {
            open(spot);
          }
        });

        /* Hover — only on devices with a real mouse, so touch never double-fires.
         Focus-mirrors-hover lives in here too: on touch, `focus` fires right
         before `click` on tap, which raced the click handler above and made
         the first tap open-then-instantly-close. Scoping it to canHover fixes
         that; native buttons still fire `click` on Enter/Space for keyboard users. */
        if (canHover) {
          spot.addEventListener('mouseenter', function () {
            closeAll(spot);
            open(spot);
          });

          spot.addEventListener('mouseleave', function () {
            close(spot, false);
          });

          toggle.addEventListener('focus', function () {
            closeAll(spot);
            open(spot);
          });

          spot.addEventListener('focusout', function (event) {
            if (!spot.contains(event.relatedTarget)) {
              close(spot, false);
            }
          });
        }

        if (closeBtn) {
          closeBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            close(spot, true);
          });
        }

        card.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      });

      document.addEventListener('click', function () {
        closeAll(null);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeAll(null);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-cbp-banner]').forEach(initBanner);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-cbp-banner]');
      if (section) initBanner(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }
  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom,
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      } else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;

          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return (
        this.header.classList.contains('shopify-section-header-sticky') &&
        !this.header.classList.contains('shopify-section-header-hidden') &&
        document.body.classList.contains('shopify-body-section-header-sticky') &&
        !document.body.classList.contains('shopify-body-section-header-hidden')
      );
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section_custom_slidesshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlideshow(root) {
    var track = root.querySelector('[data-cs-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cs-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cs-dot]'));
    var prevBtn = root.querySelector('[data-cs-prev]');
    var nextBtn = root.querySelector('[data-cs-next]');
    var progressFill = root.querySelector('[data-cs-progress]');
    var total = slides.length;
    var current = 0;
    var autoplay = root.getAttribute('data-cs-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-cs-interval'), 10) || 5000;
    var timer = null;

    if (total < 2) return;

    function goTo(index) {
      current = (index + total) % total;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      if (progressFill) {
        progressFill.style.setProperty('--cs-progress', ((current + 1) / total));
      }
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = window.setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-cs-goto'), 10) || 0;
        goTo(index);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    goTo(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-cs-slideshow]').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-cs-slideshow]');
    if (section) initSlideshow(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
